import { render, staticRenderFns } from "./OurPartners.vue?vue&type=template&id=53247bb6&scoped=true&"
import script from "./OurPartners.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OurPartners.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OurPartners.vue?vue&type=style&index=0&id=53247bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53247bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53247bb6')) {
      api.createRecord('53247bb6', component.options)
    } else {
      api.reload('53247bb6', component.options)
    }
    module.hot.accept("./OurPartners.vue?vue&type=template&id=53247bb6&scoped=true&", function () {
      api.rerender('53247bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/OurPartners.vue"
export default component.exports